<template>
    <div>
        <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>设备管理</el-breadcrumb-item>
            <el-breadcrumb-item>有人应急门</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <br>
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="5">
                    <el-input placeholder="门店名称/序号" clearable v-model="queryInfo.storeName" @clear="handleQuery()" @keyup.enter.native="handleQuery()" style="width: 100%">
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-input placeholder="网关名称" clearable v-model="queryInfo.gatewayName" @clear="handleQuery()" @keyup.enter.native="handleQuery()" style="width: 100%"></el-input>
                </el-col>
                <el-col :span="4">
                    <el-input placeholder="设备SN" clearable v-model="queryInfo.usrSn" @clear="handleQuery()" @keyup.enter.native="handleQuery()" style="width: 100%"></el-input>
                </el-col>
                <el-col :span="3">
                    <el-select v-model="queryInfo.usrStatus" clearable placeholder="在线状态" @change="getList()" style="width: 100%">
                        <el-option label="在线" value="Y"></el-option>
                        <el-option label="离线" value="N"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" icon="el-icon-search" @click="handleQuery()">查询</el-button>
                    <el-button @click="handleReset()">重置</el-button>
                </el-col>
                <el-col :span="4" style="text-align: right;">
                    <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增设备</el-button>
                </el-col>
            </el-row>
            <!--搜索与添加区域-->
            <br>
            <!--列表区域-->
            <el-table v-loading="loading" :data="list" style="width: 100%" stripe size="middle" height="780">
                <el-table-column label="序号" type="index" width="100"></el-table-column>
                <el-table-column label="门店名称" prop="storeName" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column label="网关名称" prop="gatewayName" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column label="设备SN" prop="usrSn" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="IMEI" prop="usrImei" width="160" show-overflow-tooltip></el-table-column>
                <el-table-column label="ICCID" prop="usrIccid" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column label="IMSI" prop="usrImsi" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column label="订阅主题" prop="usrTopic" width="220" show-overflow-tooltip></el-table-column>
                <el-table-column label="发布主题" prop="usrPushTopic" width="220" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag type="success" size="small" v-if="scope.row.usrStatus === 'Y'">在线</el-tag>
                        <el-tag type="info" size="small" v-else-if="scope.row.usrStatus === 'N'">离线</el-tag>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="160">
                    <template slot-scope="scope">
                        <div class="button-group">
                            <el-tooltip content="编辑" placement="top" :enterable="false">
                                <el-button type="success" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>
                            </el-tooltip>
                            <el-tooltip content="删除" placement="top" :enterable="false">
                                <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row)"></el-button>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[50, 500, 1000]" :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
        </el-card>

        <!--新增/编辑对话框-->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" @close="dialogClosed">
            <el-form :model="formData" :rules="formRules" ref="formRef" label-width="90px">
                <el-form-item label="选择门店" prop="storeId">
                    <el-select v-model="formData.storeId" filterable clearable placeholder="请选择门店" @change="handleStoreChange" style="width: 380px;" :disabled="isEdit">
                        <el-option v-for="item in storeList" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="网关名称" prop="gatewayName">
                    <el-input v-model="formData.gatewayName" placeholder="请输入网关名称" style="width: 380px;"></el-input>
                </el-form-item>
                <el-form-item label="设备SN" prop="usrSn">
                    <el-input v-model="formData.usrSn" placeholder="必填，唯一" style="width: 380px;"></el-input>
                </el-form-item>
                <el-form-item label="IMEI" prop="usrImei">
                    <el-input v-model="formData.usrImei" placeholder="IMEI" style="width: 380px;"></el-input>
                </el-form-item>
                <el-form-item label="ICCID" prop="usrIccid">
                    <el-input v-model="formData.usrIccid" placeholder="ICCID" style="width: 380px;"></el-input>
                </el-form-item>
                <el-form-item label="IMSI" prop="usrImsi">
                    <el-input v-model="formData.usrImsi" placeholder="IMSI" style="width: 380px;"></el-input>
                </el-form-item>
                <el-form-item label="订阅主题" prop="usrTopic">
                    <el-input v-model="formData.usrTopic" placeholder="必填，服务端→设备" style="width: 380px;"></el-input>
                </el-form-item>
                <el-form-item label="发布主题" prop="usrPushTopic">
                    <el-input v-model="formData.usrPushTopic" placeholder="必填，设备→服务端" style="width: 380px;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm" :loading="btnLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'DeviceUsr',
    data() {
        return {
            queryInfo: {
                storeId: null,
                storeName: '',
                gatewayName: '',
                usrSn: '',
                usrStatus: '',
                pagenum: 1,
                pagesize: 50
            },
            total: 0,
            list: [],
            loading: false,

            dialogVisible: false,
            isEdit: false,
            formData: {
                id: null,
                storeId: null,
                gatewayName: '',
                usrSn: '',
                usrImei: '',
                usrIccid: '',
                usrImsi: '',
                usrTopic: '',
                usrPushTopic: '',
                usrStatus: 'N'
            },
            formRules: {
                storeId: [{ required: true, message: '请选择门店', trigger: 'change' }],
                usrSn: [{ required: true, message: '请输入设备SN', trigger: 'blur' }],
                usrTopic: [{ required: true, message: '请输入订阅主题', trigger: 'blur' }],
                usrPushTopic: [{ required: true, message: '请输入发布主题', trigger: 'blur' }]
            },
            btnLoading: false,
            storeList: []
        }
    },
    computed: {
        dialogTitle() {
            return this.isEdit ? '编辑应急门设备' : '新增应急门设备'
        }
    },
    created() {
        this.getList()
        this.fetchStoreList()
    },
    methods: {
        async getList() {
            this.loading = true
            try {
                // 接口期望 page / pageSize，内部统一用 pagenum / pagesize
                const payload = {
                    storeId: this.queryInfo.storeId,
                    storeName: this.queryInfo.storeName,
                    gatewayName: this.queryInfo.gatewayName,
                    usrSn: this.queryInfo.usrSn,
                    usrStatus: this.queryInfo.usrStatus,
                    page: this.queryInfo.pagenum,
                    pageSize: this.queryInfo.pagesize
                }
                const { data: res } = await this.$http.post('device/usr/list', payload)
                if (res.status === 0 || res.code === 200) {
                    this.list = res.data && (res.data.list || res.data) || []
                    this.total = (res.data && res.data.total) || 0
                } else {
                    this.$message.error(res.msg || '获取列表失败')
                }
            } catch (error) {
                console.error('获取USR设备列表异常:', error)
                this.$message.error('获取列表失败')
            } finally {
                this.loading = false
            }
        },
        handleQuery() {
            this.queryInfo.pagenum = 1
            this.getList()
        },
        handleReset() {
            this.queryInfo = {
                storeId: null,
                storeName: '',
                gatewayName: '',
                usrSn: '',
                usrStatus: '',
                pagenum: 1,
                pagesize: 50
            }
            this.getList()
        },
        handleSizeChange(val) {
            this.queryInfo.pagesize = val
            this.queryInfo.pagenum = 1
            this.getList()
        },
        handleCurrentChange(val) {
            this.queryInfo.pagenum = val
            this.getList()
        },
        async fetchStoreList() {
            try {
                const { data: res } = await this.$http.get('store/')
                if (res.status === 0 || res.code === 200) {
                    this.storeList = res.data || []
                }
            } catch (e) {
                console.error('拉取门店列表失败', e)
            }
        },
        handleStoreChange(id) {
            const s = this.storeList.find(i => i.id === id)
            if (s && !this.formData.gatewayName) {
                // 不自动填充网关名称
            }
        },
        dialogClosed() {
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields()
            }
        },
        handleAdd() {
            this.isEdit = false
            this.formData = {
                id: null,
                storeId: null,
                gatewayName: '',
                usrSn: '',
                usrImei: '',
                usrIccid: '',
                usrImsi: '',
                usrTopic: '',
                usrPushTopic: '',
                usrStatus: 'N'
            }
            this.dialogVisible = true
            this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
        },
        async handleEdit(row) {
            this.isEdit = true
            try {
                const { data: res } = await this.$http.get('device/usr/detail', { params: { id: row.id } })
                if (res.status === 0 || res.code === 200) {
                    const detail = res.data || {}
                    this.formData = {
                        id: detail.id,
                        storeId: detail.storeId,
                        gatewayName: detail.gatewayName || '',
                        usrSn: detail.usrSn || '',
                        usrImei: detail.usrImei || '',
                        usrIccid: detail.usrIccid || '',
                        usrImsi: detail.usrImsi || '',
                        usrTopic: detail.usrTopic || '',
                        usrPushTopic: detail.usrPushTopic || '',
                        usrStatus: detail.usrStatus || 'N'
                    }
                    this.dialogVisible = true
                    this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
                } else {
                    this.$message.error(res.msg || '获取详情失败')
                }
            } catch (error) {
                console.error('获取详情异常:', error)
                this.$message.error('获取详情失败')
            }
        },
        submitForm() {
            this.$refs.formRef.validate(async valid => {
                if (!valid) return
                this.btnLoading = true
                try {
                    let res
                    if (this.isEdit) {
                        res = await this.$http.post('device/usr/update', this.formData)
                    } else {
                        res = await this.$http.post('device/usr/add', this.formData)
                    }
                    const data = res.data
                    if (data.status === 0 || data.code === 200) {
                        this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
                        this.dialogVisible = false
                        this.getList()
                    } else {
                        this.$message.error(data.msg || '操作失败')
                    }
                } catch (error) {
                    console.error('提交异常:', error)
                    this.$message.error('操作失败')
                } finally {
                    this.btnLoading = false
                }
            })
        },
        handleDelete(row) {
            this.$confirm(`确定删除设备「${row.usrSn || row.gatewayName || row.id}」吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const { data: res } = await this.$http.post('device/usr/delete', null, { params: { id: row.id } })
                    if (res.status === 0 || res.code === 200) {
                        this.$message.success('删除成功')
                        this.getList()
                    } else {
                        this.$message.error(res.msg || '删除失败')
                    }
                } catch (error) {
                    console.error('删除异常:', error)
                    this.$message.error('删除失败')
                }
            }).catch(() => {})
        }
    }
}
</script>
